import React, { useEffect, useState } from "react";
import { DispatchProp, connect } from "react-redux";
import { useDispatch } from "react-redux";
import {
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CToggler,
  CImg,
} from "@coreui/react";
import { cilSettings, cilBullhorn } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import Store from "../store";
import NavDropDown from "../components/NavDropDown";
// routes config
import routes from "../routes";
import { login_success, logout, navigate_to } from "../state/actions";
import { State } from "../store";
import { getUser } from "../api/users";
import { Link, NavLink } from "react-router-dom";
type Props = {
  toggleSidebarMobile: (x: boolean) => void;
  title: string;
} & DispatchProp<any>;

const TheHeader: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const [loggedinuser, setLoggedUser] = useState<any>({
    name: "",
    role: "",
  });

  const sidebarShow = "responsive";
 

  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow)
      ? true
      : "responsive";
    dispatch({ type: "set", sidebarShow: val });
    props.toggleSidebarMobile(true);
  };

  useEffect(() => {
    // @ts-ignore
    let user = Store?.store?.getState().auth.user;
    let current_user = getUser(user?.id);
    current_user.then((data) => {
      setLoggedUser({
        name: data.firstName +" "  + data.lastName,
        role: data?.role?.role,
      });
    });
  }, []);

  const myLogout = () => {
    props.dispatch(logout());
    localStorage.clear()
  };

  
  const handleLogout = () => {

    localStorage.clear()
    props.dispatch(logout());
   
  };

  const [toggleNav, settoggleNav] = useState(false);
  const handlePopup = () => {
    settoggleNav(!toggleNav);
  };

  const gotoleads = () => {

    let data: any = localStorage.getItem('logindata')
    let res = JSON.parse(data)
    // console.log(dia1, "newdata");
    let user = JSON.parse(atob(res?.jwtToken.split('.')[1]))
    // let JWTtoken = atob(data?.jwtToken.split('.')[1])
    // const user = JSON.parse(JWTtoken);
    dispatch(login_success({
      token: res?.jwtToken,
      user: {
        ...user,
        permissions: user.permissions.split(",")

      },
    }))
  
  }

  return (
    <CHeader colorScheme="dark">
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none text-white"
        onClick={toggleSidebarMobile}
      />
      <CHeaderBrand className="d-lg-none" to="/">
        <CImg 
          src="/images/logo.png"
          height={35}
          className="c-sidebar-brand-full"
        />
      </CHeaderBrand>

      <CHeaderNav className="d-md-down-none mr-auto">
        <CHeaderNavItem className="px-3">
          <h1 className={"page-header-title mb-0"}>{props.title}</h1>
        </CHeaderNavItem>
      </CHeaderNav>

      <CHeaderNav className="pl-3 align-item-center top-right-menu">
        <div className={"c-header-nav-item"}>
          <h6 className={"mb-0 px-2 py-1 d-md-down-none"}>
            Welcome to Milford
          </h6>
        </div>
        <div className="c-header-nav-item profileDet"> {loggedinuser.name} ({loggedinuser.role}) </div>

        {loggedinuser?.role !=="client" && <NavDropDown
          itemKey={(_, i) => i.toString()}
          items={[{ content: () => "Logout", onClick: () => myLogout() }]}
        >
          <CIcon size="lg" content={cilSettings} />
        </NavDropDown>}
        {loggedinuser?.role=="client" && <div className="nav-heart-user">
          <div className="nav-heart">
            <Link to="/property-list/favourites">
              <i className="fa-solid fa-heart link-dark"></i>
            </Link>
          </div>

          <div className="profile-dropdown">
            <div
              className="nav-user profile-dropdown"
              onClick={() => handlePopup()}
            >
              <i className="fa-solid fa-user"></i>
            </div>
            {toggleNav === true ? (
              <ul>
                {/* <li className="loggedinuser-name">

                  {loggedinuser.name} ({loggedinuser.role})

                </li> */}
             
               <li>
                  <Link to="/property-list/clientprofile">Profile</Link>
                </li>
                <li >
                  <NavLink to={{
                    pathname: "/leads",
                    state: { prevPath: location.pathname },
                  }} onClick={gotoleads}> Dashboard</NavLink>


                </li>
                <li>
                  <Link to="/property-list/messages">Messages</Link>
                </li>
                <li>
                  <Link to="/property-list/savedlists">Save Searches</Link>
                </li>
                <li>
                  <Link to="/property-list/favourites">Favourites</Link>
                </li>
                <li>
                  <Link to="/property-list/dislike">Dislikes</Link>
                </li>
                <li>
                  <Link to="/property-list/recentlyviewed">
                    Recently Viewed
                  </Link>
                </li>
                <li>
                  <Link to="/property-list/yourteam">Your Team</Link>
                </li>
                <li>
                  <Link to="/property-list/account">Account Settings</Link>
                </li>
                
                <hr />

                <li onClick={handleLogout}>
                  <Link className="btn sign-out-btn" to="/login">
                    SIGN OUT
                  </Link>
                </li>
              </ul>
            ) : ""}

          </div>
        </div>}
      </CHeaderNav>
    </CHeader>
  );
};

export default connect((state: State) => ({
  title: state.navigate.title,
}))(TheHeader);
